import {
  ConsentOrdersFinancialContributionsSchema,
  FinancialContributionIcon,
  InitialDetails,
  RadioSelect,
  RangeSlider,
  TextArea
} from "@fla/components";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";

interface IProps {
  formId: string;
  store: InitialDetails;
  onSubmit: (values: InitialDetails) => void;
}

export default function FinancialContributions({ onSubmit, formId, store }: IProps) {
  const { handleSubmit, watch, setValue, control } = useForm({
    mode: "all",
    defaultValues: store,
    resolver: yupResolver(ConsentOrdersFinancialContributionsSchema)
  });

  return (
    <form id={formId} className="space-y-5" onSubmit={handleSubmit(onSubmit)}>
      <div className="mb-8 pb-8 border-b">
        <FinancialContributionIcon classes="w-14 h-14 mx-auto mb-5" />

        <h3 className="text-center">Financial Contributions</h3>
      </div>

      <p className="text-gray-500 text-sm mb-4">
        This question relate to financial contributions both during the relationship and after separation. Consider if
        they were <b>generally equal</b>.
      </p>

      <RadioSelect
        title="Based on the previous examples, were financial contributions generally equal?"
        control={control}
        name="contributions.financial_equal"
        id="contributions.financial_equal"
        options={["yes", "no"]}
        classes="col-span-1"
        onChange={val => {
          if (val === "no") {
            setValue("contributions.financial_contribution", "50");
          } else {
            setValue("contributions.financial_contribution", "");
            setValue("contributions.financial_not_equal_comments", "");
          }
        }}
      />

      {watch("contributions.financial_equal") === "no" ? (
        <>
          <RangeSlider
            title="Overall, what were the finanical contributions for each of you"
            control={control}
            name="contributions.financial_contribution"
            id="contributions.financial_contribution"
            exName={store?.spouse?.first_name || "N/A"}
          />

          <TextArea
            title="Give details on why the financial contributions were not equal"
            control={control}
            name="contributions.financial_not_equal_comments"
            id="contributions.financial_not_equal_comments"
            placeholder="details"
            // classes="col-span-1"
            subTitle="E.g who earned more throughout the relationship, who brought in greater assets, who contributed more to assets and how much someone received from any gift, inheritance, compensation or redundancy "
          />
        </>
      ) : null}
    </form>
  );
}

/*
list of Australian States
Overseas 

show the country (drop down)
shw input box - overseas_state

*/
